import React from 'react';
import loading from './plant.gif';
import loadingBar from './loading-bar.gif';
import {
  Box,
  makeStyles
} from '@material-ui/core';


import Page from 'src/components/Page';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'white',
    height: '100vh',
  },
  paper: {
    // backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    width: 'fit-content'
  }
}));

const LoginView = () => {
  const classes = useStyles();



  return (
    <Page
      className={classes.root}
      title="Login"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
        alignItems="center"
      >
        <img src={loading} href="loading" height="150px" style={{marginBottom:-25,zIndex:2}}/>
        <img src={loadingBar} href="loading" height="120px" style={{marginBottom:50,marginRight:10}}/>
  
      </Box>
    </Page>
  );
};

export default LoginView;